export default {
	title: 'Spárovaná produkce',
	client: 'Klient',
	contractNo: 'Číslo smlouvy',
	importDateKCL: 'Datum importu do KCL',
	importDateBrutto: 'Datum importu do Brutta',
	BpProduction: 'Produkce BP',
	JpProduction: 'Produkce JP',
	businessShare: 'Podíl na produkci',
};
